<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1100px"
      line-form
      unit="费用单"
      edit-title
      id-key="DocId"
      :data="data"
      :get-data-func="api.info"
      form-label-width="95px"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @opened="onOpened"
      :form-rules="rules"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row class="border">
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="费用单编号" prop="DocNo">
                <span v-if="Mode==0" class="detail-span">{{data.DocNo}}</span>
                <el-input size="mini" v-else v-model="data.DocNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="单据日期" prop="DocDate">
                <el-date-picker
                  v-model="data.DocDate"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd"
                  :editable="false"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="往来单位" prop="TradeUnitId" >
                <!-- <select-input:rules="data.NeedTradeUnit?tu:null"
                  placeholder="请选择单位"
                  :label="data.TradeUnitName"
                  v-model="data.TradeUnitId"
                  @click="openTradeunit"
                /> -->
                <customer  @restaurants='setSupplier' :state='data.TradeUnitName' :typeList="[2, 3]"/>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="票据类型" prop="InvoiceTypeId">
                <invoice-select
                  v-model="data.InvoiceTypeId"
                  @change="invoiceChange"
                  @input="invoiceinput"
                  :clearable="false"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="业务类型" prop="BusinessTypeId">
                <business-select
                  v-model="data.BusinessTypeId"
                  :params="{Kind:'应付',SourceType:'费用单'}"
                  @change="onChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="经办人" prop="ClerkId">
                <select-input
                  placeholder="请选择经办人"
                  :label="data.ClerkName"
                  v-model="data.ClerkId"
                  @click="openEmp"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="Remark">
                <el-input size="mini" type="textarea" v-model="data.Remark" placeholder="请输入备注"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <template v-if="data.InvoiceTypeId!=null">
          <edit-list2 v-if="data.InvoiceTypeName=='收据'" ref="editList" />
          <edit-list1 v-else ref="editList" />
        </template>
        <div class="row-tb-head" style="margin-top: 10px;margin-bottom: 20px;">
          <span>付款信息</span>
          <div style="float: right;">
            <!-- <el-button size="mini" type="primary" icon="el-icon-plus" @click="addReceipt">添加</el-button> -->
          </div>
        </div>
        <el-table border class="tb-c-head" :data="data.RpCostDocPays"  @row-click="rowClick">
          <el-table-column prop="SettleName" label="结算方式" min-width="110">
            <template slot-scope="{row}">
              <el-select size="mini" v-model="row.SettleId" @change="setSettle(row)" placeholder="请选择结算方式">
                <template v-for="(i,key) in Settles">
                  <el-option :key="key" :label="i.SettleName" :value="i.SettleId"></el-option>
                </template>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="AccountName" label="付款账号">
            <template slot-scope="{row}">
              <select-input
                placeholder="请选择账号"
                :label="row.AccountName"
                v-model="row.AccountId"
                @click="openAccount(row)"
              />
            </template>
          </el-table-column>
          <el-table-column prop="PayAmount" label="付款金额">
            <template slot-scope="{row}">
              <el-input size="mini" v-model="row.PayAmount" @input="onInput(row)" placeholder="请输入付款金额"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="95" fixed="right">
            <template slot-scope="{row,$index}">
              <!-- <el-link style="margin-right:10px" @click="copyRow(row,$index)" :underline="false">复制</el-link> -->
              <el-link @click.stop="delReceipt(row,$index)" :underline="false">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template slot="footer" slot-scope="{isLoading}">
        <!-- <el-button type="success" :loading="isLoading" @click="save('submit')">提 交</el-button> -->
        <el-button size="mini" type="primary" :loading="isLoading" @click="save('save')">保 存</el-button>
        <el-button size="mini" @click="close">关 闭</el-button>
      </template>
      <account-dialog ref="accountDialog" in-dialog selectable @select="setAccount" />
      <tradeunit-dialog ref="tradeunitDialog" in-dialog selectable @select="setTradeunit"/>
      <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    </common-dialog>
  </div>
</template>
<script>
import customer from "@/components/common/customer/customer";
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import accountDialog from "@/components/basedoc/account/listDialog";
import businessSelect from "@/components/basedoc/business/select";
import invoiceSelect from "@/components/basedoc/invoice/select";
// import tradeunitDialog from "@/components/basic/customer/listDialog";
import tradeunitDialog from "@/components/basicinfo/basic/logistics/listDialog";
import empDialog from "@/components/sales/business/empDialog";
import editList1 from "./editList1";
import editList2 from "./editList2";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    accountDialog,
    businessSelect,
    invoiceSelect,
    tradeunitDialog,
    empDialog,
    editList1,
    editList2,
    customer
  },
  data() {
    return {
      api: require("@/api/fund/contactcash/cost").default,
      code_api: require("@/api/sy/bill").default,
      settle_api: require("@/api/sale/settle").default,
      cost_api: require("@/api/sale/cost").default,
      data: {
        DocId: 0,
        DocNo: "", //编号
        DocDate: this.$commonJs.getToday(), //单据日期
        TradeUnitId: null, //往来单位Id
        TradeUnitName: "",
        UnitType: 0, //类型 - 1:零售 2:批发 3:供应商
        // DocType: null,
        SourceDocId: null,
        SourceDocNo: "",
        SourceBillName: "",
        BusinessTypeId: null, //业务类型
        InvoiceTypeId: null, //票据类型 - 0:不开票 SY_InvoiceType
        InvoiceTypeName: "",
        ClerkId: null, //经办人
        ClerkName: "",
        Amount: null, //金额
        TaxAmount: null, //税额
        IncTaxAmount: null, //含税金额
        NoTaxAmount: null, //无税金额
        ReceiptAmount: null, //收款税额
        RemainAmount: null, //剩余金额
        Remark: "", //备注
        NeedTradeUnit: true,

        RpCostDocDtss: [],
        RpCostDocPays: [
            {
              DocReceiptId: 0,
              DocId: 0,
              SettleId: null,
              SettleName: "",
              AccountId: null,
              AccountName: "",
              PayAmount: null, //收款金额
              T: 0,
            }
        ],
      },
      Mode: 0,
      DelRpCostDocPays: [],
      current: null,
      Settles: [], //结算方式列表
      Cost: {length:0,Data:[]}, //费用
      isMB: this.$store.state.isMB,
      rules: {
        DocNo: [{ required: true, message: "费用单编号不能为空" }],
        DocDate: [{ required: true, message: "单据日期不能为空" }],
        // ClerkId: [{ required: true, message: "请选择经办人" }],
        BusinessTypeId: [{ required: true, message: "请选择业务类型" }],
        InvoiceTypeId: [{ required: true, message: "请选择票据类型" }],
        TradeUnitId: [{ required: true, message: "请选择单位" }],
      },
      //tu: [{ required: true, message: "请选择单位" }],
    };
  },
  methods: {
    setSupplier(data) {
      
      this.data.TradeUnitId = data.TradeUnitId;
      this.data.TradeUnitName = data.TradeUnitName;
      this.data.TradeUnitType = data.TradeUnitType;
    },
    onCreateOpened() {
      this.data.RpCostDocPays= [
          {
            DocReceiptId: 0,
            DocId: 0,
            SettleId: null,
            SettleName: "",
            AccountId: null,
            AccountName: "",
            PayAmount: null, //收款金额
            T: 0,
          }
      ]
      var user = this.$store.state.user;
      // 
      if (user) {
        this.data.ClerkId = user.empId;
        this.data.ClerkName = user.name;
      }
      this.code_api.getDefaultSerialNo("费用单").then((res) => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data;
        } else {
          this.$message.warning("获取费用单编号失败");
        }
      });
      // this.addReceipt();
    },
    onEditOpened(data) {
      this.data.RpCostDocDtss = data.RpCostDocDtsDtos.map((x) => {
        // return { ...x, T: null };
        return { ...x, T: 1 };
      });
      this.data.RpCostDocPays = data.RpCostDocPayDtos.map((x) => {
        // return { ...x, T: null };
        return { ...x, T: 1 };
      });
      if(this.data.RpCostDocPays.length==0 ){
        this.data.RpCostDocPays= [
          {
            DocReceiptId: 0,
            DocId: 0,
            SettleId: null,
            SettleName: "",
            AccountId: null,
            AccountName: "",
            PayAmount: null, //收款金额
            T: 0,
          }
      ]
      }
      this.$nextTick(() => {
        this.$refs.editList.setData(this.data.RpCostDocDtss);
        // this.$refs.editList.setCost(this.Cost);
      });
    },
    onOpened() {
      this.settle_api.list({ Status: 1 }).then((res) => {
        if (res.Code == 0) this.Settles = res.Data;
      });
      this.cost_api.list({ Status: 1,pageIndex:1,pageSize:7  }).then((res) => {
        if (res.Code == 0) {this.Cost.Data = res.Data;this.Cost.length=res.Count;} 

      });
    },
    onChange(data) {
      if (data) this.data.NeedTradeUnit = data.NeedTradeUnit;
      else this.data.NeedTradeUnit = true;
      this.$refs.dialog.clearValidate();
    },
    invoiceinput(e,data,type){
      this.$nextTick(() => {
        this.$refs.editList.setCost(this.Cost, data.DefTaxRate,type);
      });
    },
    invoiceChange(e,data,type) {
      let DelData=[]
      if(this.data.InvoiceTypeId!=null && this.$refs.editList){
      this.$refs.editList.Data.forEach(row=>{
       if (row.T != 0) DelData.push({ ...row, T: 2 });
      })
      }
      if(data.InvoiceTypeName!='收据'){
        this.$refs.editList.Data=[{
        DocDtsId: 0,
        DocId: 0,
        CostId: 0, //费用
        CostCode: "",
        CostName: "",
        Amount: null, //金额
        TaxRate: this.DefTaxRate, //税率
        TaxAmount: null, //税额
        IncTaxAmount: null, //含税金额
        // NoTaxAmount: null, //无税金额
        // WriteoffAmount: null, //累计结款金额
        Remark: "",
        T: 0,
      }]
      }
      this.data.InvoiceTypeName = data.InvoiceTypeName;
      this.$nextTick(() => {
        this.$refs.editList.setCost(this.Cost, data.DefTaxRate,type);
        this.$refs.editList.DelData= DelData
      });
    },
    rowClick(row) {
       if(!this.readonly){
          var index = this.data.RpCostDocPays.indexOf(row);
          if (index + 1 == this.data.RpCostDocPays.length) {
            // 
            this.addReceipt();
          }
       }
    },
    addReceipt() {
      var item = {
        DocReceiptId: 0,
        DocId: this.data.DocId,
        SettleId: null,
        SettleName: "",
        AccountId: null,
        AccountName: "",
        PayAmount: null, //收款金额
        T: 0,
      };
      this.data.RpCostDocPays.push(item);
    },
    setSettle(row) {
      
      var settle = this.Settles.find((x) => x.SettleId == row.SettleId);
      row.AccountId = settle.AccountId;
      row.AccountName = settle.AccountName;
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData({ Status: 1 });
      });
    },
    setEmp(data) {
      this.data.ClerkId = data.EmpId;
      this.data.ClerkName = data.EmpName;
    },
    openAccount(row) {
      this.current = row;
      this.$refs.accountDialog.open().then((that) => {
        that.getData();
      });
    },
    setAccount(data) {
      this.current.AccountId = data.AccountId;
      this.current.AccountName = data.AccountName;
    },
    openTradeunit() {
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData();
      });
    },
    setTradeunit(data) {
       this.data.TradeUnitId = data.Id
      this.data.TradeUnitName = data.Name
      this.data.TradeUnitType = data.TradeUnitType
    },
    onInput(row) {
      row.T = row.T == 0 ? 0 : 1;
      // row.PayAmount = this.$commonJs.obj.toNumber(row.PayAmount);
      var items = this.data.RpCostDocPays.filter((x) => !!x.PayAmount).map(
        (x) => parseFloat(x.PayAmount)
      );
      var amount = null;
      if (items.length > 0) {
        amount = items.reduce((a, b) => {
          return a + b;
        });
      }
      this.data.ReceiptAmount = amount;
    },
    delReceipt(row, index) {
      if (row.T != 0) this.DelRpCostDocPays.push({ ...row, T: 2 });
          if(this.data.RpCostDocPays.length==1){
            this.data.RpCostDocPays.splice(index, 1);
            this.addReceipt();
        }else{
          this.data.RpCostDocPays.splice(index, 1);
        }
    },
    save(type) {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;

        var data = this.$commonJs.obj.removeNullKey(this.data);
        data.RpCostDocDtss = this.$refs.editList.Data.filter(
          (x) => x.CostId != 0
        );
        if (data.RpCostDocDtss.every((x) => !x.CostId) && data.RpCostDocDtss.every((x) => !x.Amount)) {
        this.$message.warning("收入信息不能为空");
        return false;
        }

        for (let index = 0; index < data.RpCostDocDtss.length; index++) {
              if(!!data.RpCostDocDtss[index].CostId || !!data.RpCostDocDtss[index].Amount ){
            if (!data.RpCostDocDtss[index].CostId) {
              this.$message.warning("费用信息 - 费用名称不能为空");
              return;
            }
            if (!data.RpCostDocDtss[index].Amount) {
               this.$message.warning("费用信息 - 金额不能为空");
              return;
            }
          }
        }

        if (data.InvoiceTypeName != "收据") {
          var taxRate = data.RpCostDocDtss.some((x) => x.TaxRate === "");
          if (taxRate) {
            this.$message.warning("费用信息 - 税率不能为空");
            return;
          }
          data.RpCostDocDtss.forEach((x) => {
            if (x.TaxAmount == null) x.TaxAmount = 0;
          });
          // var taxAmount = data.RpCostDocDtss.every((x) => !!x.TaxAmount);
          // if (!taxAmount) {
          //   this.$message.warning("费用信息 - 税额不能为空");
          //   return;
          // }
          // var incTaxAmount = data.RpCostDocDtss.every(
          //   (x) => !!x.IncTaxAmount
          // );
          // if (!incTaxAmount) {
          //   this.$message.warning("费用信息 - 含税金额不能为空");
          //   return;
          // }
        }

        // if (this.data.RpCostDocPays.every((x) => !x.SettleId) && this.data.RpCostDocPays.every((x) => !x.AccountId)&& this.data.RpCostDocPays.every((x) => !x.PayAmount)) {
        // this.$message.warning("付款信息不能为空");
        // return false;
        // }
        if(this.data.RpCostDocPays.length>0){
          for (let index = 0; index < data.RpCostDocPays.length; index++) {
              if(!!data.RpCostDocPays[index].SettleId || !!data.RpCostDocPays[index].AccountId|| !!data.RpCostDocPays[index].PayAmount ){
            if (!data.RpCostDocPays[index].SettleId) {
              this.$message.warning("付款信息 - 结算方式不能为空");
              return;
            }
            if (!data.RpCostDocPays[index].AccountId) {
               this.$message.warning("付款信息 - 账号不能为空");
              return;
            }
            if (!data.RpCostDocPays[index].PayAmount) {
                this.$message.warning("付款信息 - 付款金额不能为空");
              return;
            }
          }
          
        }
          data.RpCostDocPays = data.RpCostDocPays.filter((x) => x.T != null);
          data.RpCostDocPays = data.RpCostDocPays.filter((x) => x.SettleId != null && x.AccountId != null && x.PayAmount != null);
          this.DelRpCostDocPays.forEach((x) => {
            data.RpCostDocPays.push(x);
          });

        }
        

        var DelRpCostDocDtss = this.$refs.editList.DelData;
        data.RpCostDocDtss = data.RpCostDocDtss.filter((x) => x.T != null);
        data.RpCostDocDtss.forEach((x) => (x.DocId = this.data.DocId));
        DelRpCostDocDtss.forEach((x) => {
          data.RpCostDocDtss.push(x);
        });

       
        this.$refs.dialog.isLoading = true;
        this.api[type](data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            this.$emit("close-saved");
            this.close(true);
          } else {
            this.$message.error(res.Msg);
          }
        });
      });
    },
    onClosed() {
      this.DelRpCostDocPays = [];
      this.data.RpCostDocPays = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.border{
  padding: 15px;
}
</style>